import React from 'react';

const PrimaryContactSVG = ({ isActive }) => {
  if (isActive) {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10Z"
          fill="#4279DE" />
        <path fillRule="evenodd" clipRule="evenodd"
              d="M6 10C6 9.44772 6.44772 9 7 9H13C13.5523 9 14 9.44772 14 10C14 10.5523 13.5523 11 13 11H7C6.44772 11 6 10.5523 6 10Z"
              fill="#173D84" />
        <path fillRule="evenodd" clipRule="evenodd"
              d="M6 7C6 6.44772 6.44772 6 7 6H8C8.55228 6 9 6.44772 9 7C9 7.55228 8.55228 8 8 8H7C6.44772 8 6 7.55228 6 7Z"
              fill="#173D84" />
        <path fillRule="evenodd" clipRule="evenodd"
              d="M6 13C6 12.4477 6.44772 12 7 12H13C13.5523 12 14 12.4477 14 13C14 13.5523 13.5523 14 13 14H7C6.44772 14 6 13.5523 6 13Z"
              fill="#173D84" />
        <path
          d="M10 16C10 12.6863 12.6863 10 16 10C19.3137 10 22 12.6863 22 16C22 19.3137 19.3137 22 16 22C12.6863 22 10 19.3137 10 16Z"
          fill="#6FC5F2" />
        <path d="M3.69374 18H10L4.00003 15L3.2194 17.3419C3.11148 17.6657 3.35246 18 3.69374 18Z" fill="#4279DE" />
        <path d="M16 22H20.191C20.5627 22 20.8044 21.6088 20.6382 21.2764L20 20L16 22Z" fill="#6FC5F2" />
        <path
          d="M17.656 14.3964C17.656 15.1676 17.0309 15.7928 16.2597 15.7928C15.4885 15.7928 14.8633 15.1676 14.8633 14.3964C14.8633 13.6252 15.4885 13 16.2597 13C17.0309 13 17.656 13.6252 17.656 14.3964Z"
          fill="white" />
        <path
          d="M18.7204 18.0487C18.7204 18.7015 17.6189 18.9997 16.2601 18.9997C14.9013 18.9997 13.7998 18.7015 13.7998 18.0487C13.7998 17.396 14.9013 16.4729 16.2601 16.4729C17.6189 16.4729 18.7204 17.396 18.7204 18.0487Z"
          fill="white" />
      </svg>
    );
  }

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10Z"
        fill="#A5A3AD" />
      <path fillRule="evenodd" clipRule="evenodd"
            d="M6 10C6 9.44772 6.44772 9 7 9H13C13.5523 9 14 9.44772 14 10C14 10.5523 13.5523 11 13 11H7C6.44772 11 6 10.5523 6 10Z"
            fill="#2C2C2F" />
      <path fillRule="evenodd" clipRule="evenodd"
            d="M6 7C6 6.44772 6.44772 6 7 6H8C8.55228 6 9 6.44772 9 7C9 7.55228 8.55228 8 8 8H7C6.44772 8 6 7.55228 6 7Z"
            fill="#2C2C2F" />
      <path fillRule="evenodd" clipRule="evenodd"
            d="M6 13C6 12.4477 6.44772 12 7 12H13C13.5523 12 14 12.4477 14 13C14 13.5523 13.5523 14 13 14H7C6.44772 14 6 13.5523 6 13Z"
            fill="#2C2C2F" />
      <path
        d="M10 16C10 12.6863 12.6863 10 16 10C19.3137 10 22 12.6863 22 16C22 19.3137 19.3137 22 16 22C12.6863 22 10 19.3137 10 16Z"
        fill="#C3C2C7" />
      <path d="M3.69374 18H10L4.00003 15L3.2194 17.3419C3.11148 17.6657 3.35246 18 3.69374 18Z" fill="#A5A3AD" />
      <path d="M16 22H20.191C20.5627 22 20.8044 21.6088 20.6382 21.2764L20 20L16 22Z" fill="#C3C2C7" />
      <path
        d="M17.6565 14.3964C17.6565 15.1676 17.0314 15.7928 16.2602 15.7928C15.489 15.7928 14.8638 15.1676 14.8638 14.3964C14.8638 13.6252 15.489 13 16.2602 13C17.0314 13 17.6565 13.6252 17.6565 14.3964Z"
        fill="white" />
      <path
        d="M18.7204 18.0488C18.7204 18.7015 17.6189 18.9997 16.2601 18.9997C14.9013 18.9997 13.7998 18.7015 13.7998 18.0488C13.7998 17.396 14.9013 16.4729 16.2601 16.4729C17.6189 16.4729 18.7204 17.396 18.7204 18.0488Z"
        fill="white" />
    </svg>
  );
};

export default PrimaryContactSVG;
